import Actions from "../Types";

const initialState = {
  isLoading: false,
  getApiHistorySuccess: false,
  getApiHistory: [],

  isFiltering: false,
  filteredDateApiHistory: [],
  filterDateApiHistorySuccess: false,

  filteredStatusApiHistory: [],
  filterStatusApiHistorySuccess: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_API_HISTORY_START:
      return {
        ...state,
        isLoading: true,
        getApiHistorySuccess: false,
        getApiHistory: [],
        error: null,
      };
    case Actions.GET_API_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        getApiHistorySuccess: true,
        getApiHistory: action.payload,
        error: null,
      };
    case Actions.GET_API_HISTORY_FAILURE:
      return {
        ...state,
        isLoading: false,
        getApiHistorySuccess: false,
        getApiHistory: [],
        error: action.payload,
      };
    case Actions.FILTER_DATE_APIHISTORY_START:
      return {
        ...state,
        isFiltering: true,
        error: null,
        filteredDateApiHistorySuccess: false,
      };
    case Actions.FILTER_DATE_APIHISTORY_SUCCESS:
      return {
        ...state,
        isFiltering: false,
        error: null,
        filteredDateApiHistory: action.payload,
        filteredDateApiHistorySuccess: true,
      };
    case Actions.FILTER_DATE_APIHISTORY_FAILURE:
      return {
        ...state,
        isFiltering: false,
        error: action.payload,
        filteredDateApiHistorySuccess: false,
      };
    case Actions.FILTER_STATUS_APIHISTORY_START:
      return {
        ...state,
        isFiltering: true,
        error: null,
        filteredStatusApiHistorySuccess: false,
      };
    case Actions.FILTER_STATUS_APIHISTORY_SUCCESS:
      return {
        ...state,
        isFiltering: false,
        error: null,
        filteredStatusApiHistory: action.payload,
        filteredStatusApiHistorySuccess: true,
      };
    case Actions.FILTER_STATUS_APIHISTORY_FAILURE:
      return {
        ...state,
        isFiltering: false,
        error: action.payload,
        filteredStatusApiHistorySuccess: false,
      };
    default:
      return state;
  }
};
